export default __webpack_public_path__ + "images/header_image_227fc9dea333cd5199af8e638adf140d.jpg";